module.exports = __webpack_public_path__ + "static/media/tk-TM.f0248ef7.md";